import React from 'react'
import { useDispatch } from 'react-redux'
import DocumentPreview from '../../elements/DocumentPreview'
import { userDetails, authHeader, baseUrl } from '../../../utils'
import axios from 'axios'
import { ERROR, SET_SUCCESS } from '../../../store/types'
import ModalDialog from '../../layouts/ModalDialog'
import UploadStaffDocument from './UploadStaffDocument'

const StaffDocuments = ({ staff, reload }) => {
  const documents = staff?.documents || []
  const currentStaffLoggedIn = staff?.userProfile === userDetails()?._id;
  const [addingDocument, setAddingDocument] = React.useState('');
  const [processing, setProcessing] = React.useState(false);
  const dispatch = useDispatch();

  const handleUpload = async (file) => {

      var formData = new FormData()
      formData.append('file', file.file )
      const headers = new Headers();
      headers.append("Authorization",  authHeader().Authorization);

      try {
        setProcessing(true)
        const doUpload = await fetch(`${process.env.REACT_APP_BASE_URL}/files/new`, {
            method: "POST",
            headers,
            body: formData,
        });
        const response = await doUpload.json();

        return response
      } catch (error) {
        dispatch({
          type: ERROR,
          error,
        });
      }
  }
  
    const pushUpdate = async (file) => {
    if (!file || Object.values(file).includes(null)) {
      return
    }
    const headers = { 'Content-Type': 'application/json', ...authHeader() }
    const uploaded = await handleUpload(file) 
    const payload = {
      document: { 
        _id: addingDocument._id,
        file: uploaded.data.file 
      }
    }

    try {
      setProcessing(true) 
      await axios.patch(`${baseUrl}/user/profile/staff`, payload, { headers })
      setProcessing(false)
      dispatch({
          type: SET_SUCCESS,
          payload: "Document uploaded successfully"
      })
      reload()
      setAddingDocument('')
    } catch (error) {
      console.error(error)
      dispatch({
          type: ERROR,
          error
      })
      setProcessing(false)    
    }
  }


  return (
    <>
      <section className='overflow-hidden'>
        <div className='border-b border-gray-100 px-2 py-2'>
          <h2 className='font-space-grotesk text-lg font-semibold text-gray-900'>Staff documents</h2>
          <p className='mt-1 text-sm text-vcm-dark-gray'>Documents submitted and associated with this staff profile.</p>
        </div>

        {documents.length > 0 ? (
          <div className='grid grid-cols-1 gap-4 p-2 md:grid-cols-2'>
            {documents.map((document, index) => (
              <article key={document._id || document.documentSlug || index} className='flex flex-col rounded-xl border border-gray-200 p-4 transition hover:border-vcm-light-purple hover:shadow-sm'>
                <div className='flex items-start justify-between gap-3'>
                  <div className='flex min-w-0 items-center gap-3'>
                    <span className='flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-vcm-light-purple/30 text-vcm-purple'>
                      <svg viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.8' className='h-5 w-5' aria-hidden='true'><path strokeLinecap='round' strokeLinejoin='round' d='M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.875 1.875 0 0 1 12.75 6.375v-1.5A3.375 3.375 0 0 0 9.375 1.5H6.75A2.25 2.25 0 0 0 4.5 3.75v16.5a2.25 2.25 0 0 0 2.25 2.25h5.625' /><path strokeLinecap='round' strokeLinejoin='round' d='M17.25 15.75 15 18m0 0-2.25-2.25M15 18v-6.75' /></svg>
                    </span>
                    <div className='min-w-0'>
                      <h3 className='truncate text-sm font-semibold text-gray-900'>{document.name || 'Untitled document'}</h3>
                      <p className='mt-1 text-xs text-vcm-dark-gray'>{document.documentSlug ? `Document ID: ${document.documentSlug}` : 'Staff document'}</p>
                    </div>
                  </div>
                </div>
                {document.description && <p className='mt-2 text-sm leading-6 text-vcm-dark-gray'>{document.description}</p>}
                {document.url ? <div className='mt-2 border-t border-gray-100 pt-2'><DocumentPreview documentDetails={document} /></div> : <p className='mt-5 border-t border-gray-100 pt-4 text-xs text-vcm-dark-gray'>No file has been attached yet. {currentStaffLoggedIn && 
                  <button 
                    disabled={processing} 
                    onClick={()=>{setAddingDocument(document)}} 
                    className="text-xs font-semibold font-space-grotesk text-vcm-purple rounded-lg disabled:bg-vcm-light-purple/10 disabled:cursor-pointer  bg-vcm-light-purple/30 hover:bg-vcm-light-purple transition duration-200 px-2 py-1">
                      {processing ? 'uploading...' : `Click to attach file`}
                    </button>}</p>}
              </article>
            ))}
          </div>
        ) : (
          <div className='flex min-h-[260px] flex-col items-center justify-center px-5 text-center'>
            <span className='flex h-12 w-12 items-center justify-center rounded-full bg-vcm-light-purple/30 text-vcm-purple'>
              <svg viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.8' className='h-6 w-6' aria-hidden='true'><path strokeLinecap='round' strokeLinejoin='round' d='M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.875 1.875 0 0 1 12.75 6.375v-1.5A3.375 3.375 0 0 0 9.375 1.5H6.75A2.25 2.25 0 0 0 4.5 3.75v16.5a2.25 2.25 0 0 0 2.25 2.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-2.625' /></svg>
            </span>
            <h3 className='mt-4 text-sm font-semibold text-gray-900'>No documents available</h3>
            <p className='mt-1 text-sm text-vcm-dark-gray'>Documents added for this staff member will appear here.</p>
          </div>
        )}
      </section>

      <ModalDialog
        shown={addingDocument !== ''} 
        closeFunction={()=>{setAddingDocument('')}} 
        actionFunction={()=>{}} 
        actionFunctionLabel={``}
        dialogTitle={`Upload staff document: ${addingDocument.name || 'Untitled document'}`}
        maxWidthClass='max-w-lg'
        hideActions={true}
      >
        <UploadStaffDocument documentType={addingDocument.name} returnFile={(file)=>{pushUpdate(file)}} close={()=>{setAddingDocument('')}} />
      </ModalDialog>
    </>
  )
}

export default StaffDocuments
